/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createBlock.defs.js";
export { main as default } from "./createBlock.defs.js";
